(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerColors', {
            templateUrl: 'app/components/flyer-colors/flyer-colors.html',
            controller: flyerColorsController,
            bindings: {
                flyer: '<'
            }
        });

    /** @ngInject */
    function flyerColorsController() {
        var $ctrl = this;

        var colorsToOverlap = 6;

        $ctrl.$onInit = function () {
            processColors();
        };

        function processColors() {
            $ctrl.visibleColors = [];
            $ctrl.extraColorsCount = 0;
            $ctrl.isOverlapping = false;

            if (!$ctrl.flyer || !$ctrl.flyer.flyerColors || $ctrl.flyer.flyerColors.length === 0) {
                return;
            }

            var colors = angular.copy($ctrl.flyer.flyerColors).filter(function (color) {
                return color && color.id;
            });

            if ($ctrl.flyer.groupingColorId) {
                var groupColorIndex = colors.findIndex(function (c) {
                    return c.id === $ctrl.flyer.groupingColorId;
                });

                if (groupColorIndex > -1) {
                    var groupColor = colors.splice(groupColorIndex, 1)[0];
                    groupColor.isSelected = true;
                    colors.unshift(groupColor);
                }
            } else if ($ctrl.flyer.color && $ctrl.flyer.color.id) {
                var selfColorIndex = colors.findIndex(function (c) {
                    return c.id === $ctrl.flyer.color.id;
                });

                if (selfColorIndex > -1) {
                    var selfColor = colors.splice(selfColorIndex, 1)[0];
                    colors.unshift(selfColor);
                }
            }

            $ctrl.totalColors = colors.length;
            $ctrl.isOverlapping = $ctrl.totalColors >= colorsToOverlap;

            if ($ctrl.isOverlapping) {
                $ctrl.visibleColors = colors.slice(0, colorsToOverlap);
                $ctrl.extraColorsCount = Math.max(0, $ctrl.totalColors - colorsToOverlap);
                $ctrl.colorsTranslationKey = $ctrl.extraColorsCount === 1 ? 'flyers.home.color' : 'flyers.home.colors';
            } else {
                $ctrl.visibleColors = colors;
            }
        }

        $ctrl.getZIndex = function(index) {
            return 10 - index;
        };
    }
})();
